export default "__VITE_ASSET__ee1e638c__"